import React, { useState, useEffect } from 'react';
import './helpSupport.css';
import Topbar from '../../component/Topbar';
import SideMenu from '../../component/SideMenu';
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';


const HelpSupport = () => {
    // State for navigation between detail sections
    const [activeDetail, setActiveDetail] = useState('linkMeasurements');
    // State for FAQ accordion (null means all closed, or index of open FAQ)
    const [openFaqIndex, setOpenFaqIndex] = useState(0);
    // State for search input
    const [searchQuery, setSearchQuery] = useState('');

    const detailContents = {
        linkMeasurements: {
            id: 'detailMeasurements',
            icon: 'fa-ruler',
            title: 'Taking Measurements',
            subtitle: 'How to accurately measure properties using Measro.com',
            content: (
                <>
                    <p>Accurate property measurements are essential for landscaping projects. Follow these steps:</p>
                    <ul className="detail-list">
                        <li>Go to Projects → Add New Project → Enter property address</li>
                        <li>Use the map tools to measure boundaries and areas</li>
                        <li>Upload site plans for automatic measurement extraction</li>
                        <li>Use GPS measurement tools for field measurements</li>
                        <li>Save measurements and add notes for reference</li>
                    </ul>
                    <p><strong>Pro Tip:</strong> Always measure twice and verify with satellite imagery for best accuracy.</p>
                </>
            )
        },
        linkReports: {
            id: 'detailReports',
            icon: 'fa-file-alt',
            title: 'Generating Reports',
            subtitle: 'Create and export measurement reports',
            content: (
                <>
                    <p>Generate professional measurement reports for clients and teams:</p>
                    <ul className="detail-list">
                        <li>Select project → Click "Generate Report"</li>
                        <li>Choose report format: PDF, Excel, or CSV</li>
                        <li>Customize report with your branding</li>
                        <li>Include measurement details, images, and notes</li>
                        <li>Export or share via secure link</li>
                    </ul>
                    <p><strong>Note:</strong> All reports include both imperial and metric units automatically.</p>
                </>
            )
        },
        linkProjects: {
            id: 'detailProjects',
            icon: 'fa-briefcase',
            title: 'Managing Projects',
            subtitle: 'Create, edit, and organize your measurement projects',
            content: (
                <>
                    <p>Organize all your property measurement projects efficiently:</p>
                    <ul className="detail-list">
                        <li>Create new projects with property details</li>
                        <li>Edit existing projects and update measurements</li>
                        <li>Organize projects by status, date, or client</li>
                        <li>Add team members to collaborate on projects</li>
                        <li>Archive completed projects for future reference</li>
                    </ul>
                    <p><strong>Tip:</strong> Use project templates to save time on similar properties.</p>
                </>
            )
        },
        linkTeam: {
            id: 'detailTeam',
            icon: 'fa-users',
            title: 'Team Collaboration',
            subtitle: 'Share projects with your team members',
            content: (
                <>
                    <p>Collaborate efficiently with your landscaping team:</p>
                    <ul className="detail-list">
                        <li>Go to Settings → Teams → Add Team Member</li>
                        <li>Assign roles and permissions (Viewer, Editor, Admin)</li>
                        <li>Share specific projects or entire portfolios</li>
                        <li>Leave comments and notes for team members</li>
                        <li>Track changes and updates in real-time</li>
                    </ul>
                    <p><strong>Collaboration:</strong> Team members receive email notifications for shared projects.</p>
                </>
            )
        },
        linkBilling: {
            id: 'detailBilling',
            icon: 'fa-credit-card',
            title: 'Billing & Payments',
            subtitle: 'Manage your account and payments',
            content: (
                <>
                    <p>Handle all billing and payment-related tasks:</p>
                    <ul className="detail-list">
                        <li>View and download invoices from Billing section</li>
                        <li>Update payment methods and billing information</li>
                        <li>Set up automatic payments for subscription</li>
                        <li>View usage history and billing cycles</li>
                        <li>Contact support for billing questions</li>
                    </ul>
                    <p><strong>Security:</strong> All payment information is encrypted and secure.</p>
                </>
            )
        },
        linkTroubleshoot: {
            id: 'detailTroubleshoot',
            icon: 'fa-tools',
            title: 'Troubleshooting',
            subtitle: 'Fix common issues and problems',
            content: (
                <>
                    <p>Solutions for common issues you might encounter:</p>
                    <ul className="detail-list">
                        <li><strong>Map not loading:</strong> Clear browser cache or try different browser</li>
                        <li><strong>Measurements inaccurate:</strong> Verify satellite imagery date or upload site plan</li>
                        <li><strong>Report generation failed:</strong> Check internet connection and try again</li>
                        <li><strong>Login issues:</strong> Reset password or use "Forgot Password"</li>
                        <li><strong>Slow performance:</strong> Close other tabs or applications</li>
                    </ul>
                    <p><strong>Still having issues?</strong> Contact our support team for immediate assistance.</p>
                </>
            )
        }
    };

const [faqs, setFaqs] = useState([]);
const [loading, setLoading] = useState(false);

const fetchFaq = async () => {
  const userToken = localStorage.getItem('userToken');
  try {
    setLoading(true);
    const response = await axios.get(`${baseurl}getAllFaqs`, {
      headers: { Authorization: `Bearer ${userToken}` }
    });

    console.log("🚀 API Response:", response.data);

    if (response.data.success) {
      // Use the 'faqs' key from your backend result
      // Only show 'is_active' true faqs for the user side
      const activeFaqs = response.data.faqs.filter(item => item.is_active !== false);
      setFaqs(activeFaqs);
    }
  } catch (err) {
    console.error("Error fetching FAQs:", err);
    // Optional: Fallback to static data if API fails
    // setFaqs(staticFallbackFaqs);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchFaq();
}, []);



    const handleLinkClick = (linkId) => {
        setActiveDetail(linkId);
        if (window.innerWidth < 768) {
            document.getElementById('detail-anchor').scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter' && searchQuery.trim()) {
            alert(`Searching help for: "${searchQuery}"`);
            setSearchQuery('');
        }
    };

    const handleCreateTicket = () => {
        const issue = prompt('Briefly describe your issue:');
        if (issue?.trim()) {
            alert(`Support ticket created for: "${issue}"\n\nOur team will contact you within 24 hours.`);
        }
    };

    return (

      <div className="app-container">
      <Topbar />
      <div className="main-wrapper" style={{ background: '#F4F7FE', display: 'flex' }}>
        <SideMenu />

<div className="profile-content-container p-3" style={{ flex: 1, overflow: 'auto' }}> 
        
            {/* Page Header */}
            

            <div className='page-title-section mb-3'>
              <h1>Help & Support</h1>
              <p className='page-subtitle' >Get help with Measro.com. Find answers, guides, and contact support quickly.</p>
            </div>


            {/* Quick Links */}
            <div className="quick-links">
                <h2 className="links-title">Quick Help Links</h2>
                <div className="links-grid">
                    {Object.keys(detailContents).map((key) => (
                        <div 
                            key={key}
                            className={`link-item ${activeDetail === key ? 'active-link' : ''}`}
                            onClick={() => handleLinkClick(key)}
                        >
                            <div className="link-icon">
                                <i className={`fas ${detailContents[key].icon}`}></i>
                            </div>
                            <div className="link-text">
                                <h4>{detailContents[key].title}</h4>
                                <p>{detailContents[key].subtitle}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Detail Content Section */}
            <div id="detail-anchor" style={{ scrollMarginTop: '20px' }}></div>
            {Object.keys(detailContents).map((key) => (
                <div 
                    key={detailContents[key].id}
                    className={`detail-content ${activeDetail === key ? 'active' : ''}`}
                    id={detailContents[key].id}
                >
                    <div className="detail-header">
                        <div className="detail-icon">
                            <i className={`fas ${detailContents[key].icon}`}></i>
                        </div>
                        <div>
                            <h2 className="detail-title">{detailContents[key].title}</h2>
                            <p>{detailContents[key].subtitle}</p>
                        </div>
                    </div>
                    <div className="detail-body">
                        {detailContents[key].content}
                    </div>
                </div>
            ))}

           {/* FAQ Section */}
<div className="faq-section">
    <h2 className="faq-title">Frequently Asked Questions</h2>
    <div className="faq-list">
        {loading ? (
            <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        ) : faqs.length > 0 ? (
            faqs.filter(faq => faq.is_active).map((faq, index) => (
                <div className="faq-item" key={faq.id || index}>
                    <div 
                        className="faq-question" 
                        onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                    >
                        {/* Database key is .question */}
                        {faq.question}
                        <i className={`fas fa-chevron-${openFaqIndex === index ? 'up' : 'down'}`}></i>
                    </div>
                    
                    <div 
                        className="faq-answer" 
                        style={{ 
                            display: openFaqIndex === index ? 'block' : 'none',
                            padding: '15px',
                            background: '#f9f9f9',
                            borderRadius: '0 0 8px 8px'
                        }}
                    >
                        {/* Database key is .answer */}
                        {faq.answer}
                    </div>
                </div>
            ))
        ) : (
            <div className="text-center p-4 text-muted">
                No questions found. Please check back later.
            </div>
        )}
    </div>
</div>

            {/* Compact Contact Section */}
            <div className="contact-section">
                <div className="contact-header">
                    <h2 className="contact-title">Need More Help?</h2>
                    <p className="contact-desc">Contact our support team for assistance with measurements, reports, or account management.</p>
                </div>

                <div className="contact-actions">
                    <Link to="/support-ticket" className="btn-contact"  >
                        <i className="fas fa-ticket-alt"></i> Create Support Ticket
                    </Link>
                    <button className="btn-contact" onClick={() => window.location.href = 'mailto:support@measro.com'}>
                        <i className="fas fa-envelope"></i> Email Support
                    </button>
                    {/* <button className="btn-contact" onClick={() => alert('Calling support: +1 (800) 123-4567')}>
                        <i className="fas fa-phone"></i> Call Support
                    </button> */}
                </div>

                <div className="contact-info">
                    <div className="contact-item">
                        <div className="contact-icon"><i className="fas fa-envelope"></i></div>
                        <div className="contact-text">
                            <h4>Email Support</h4>
                            <p>support@measro.com</p>
                        </div>
                    </div>
                    {/* <div className="contact-item">
                        <div className="contact-icon"><i className="fas fa-phone"></i></div>
                        <div className="contact-text">
                            <h4>Phone Support</h4>
                            <p>+1 (800) 123-4567</p>
                        </div>
                    </div> */}
                    <div className="contact-item">
                        <div className="contact-icon"><i className="fas fa-clock"></i></div>
                        <div className="contact-text">
                            <h4>Support Hours</h4>
                            <p>Mon-Fri, 9 AM - 6 PM UTC</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="simple-note">
                <p>Measro LLC. Help Center • Simple help for landscapers • Updated regularly</p>
            </div>
        </div>
        </div>
        </div>
    );
};

export default HelpSupport;